import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link } from "@/i18n/navigation";
import { formatCurrency } from "@/utils/currencyFormatter";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

export default function PopularFlightTicketCard({ item }) {
  const t = useTranslationDetector("flight");
  const linkTitle = item?.OriginCityName && item?.DestinationCityName
    ? `${item.OriginCityName} - ${item.DestinationCityName}`
    : "";
  return (
    <Link
      key={item.OutgoingDepartureDate}
      href={item.href || "/"}
      title={linkTitle}
      className="mr-4 flex shrink-0 lg:mr-6"
    >
      <div className="relative aspect-[294/253] w-[294px] overflow-hidden rounded-lg shadow-sm lg:w-[214px] xl:w-[294px]">
        <Image
          src={item?.ImageURL || ""}
          alt="cheapestflight-image"
          fill
          className="object-cover"
          sizes="(max-width: 1024px) 294px, (max-width: 1280px) 214px, 294px"
        />
        <div className="gradient-overlay absolute inset-0" />
        <div className="absolute bottom-6 left-6 z-10 space-y-2 text-white">
          <div className="flex flex-row flex-wrap items-center gap-[6px] text-xl/[26px] font-semibold">
            {" "}
            <span>{item.OriginCityName}</span>
            <FontAwesomeIcon
              className="!h-6 !w-6"
              icon={byPrefixAndName.fak["half-right-arrow"]}
            />
            <span>{item.DestinationCityName}</span>
          </div>
          <div className="flex flex-row flex-wrap">
            <span className="text-base font-semibold">
              {formatCurrency(item.Price, item.Currency, {
                decimals: 0,
                showCode: true,
              })}{" "}
            </span>
            <span className="text-base font-normal"> {t("priceFrom")}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
